'use strict';

// Checkout

$( document ).on( 'ready', function() {

	//
	// Variables
	//

	var currentTab = 'user-details';

	function getNextTab() {
		if ( currentTab === 'user-details' ) {
			return 'billing-info';
		}

		if ( currentTab === 'billing-info' ) {
			return 'payment-info';
		}
		if ( currentTab === 'payment-info' ) {
			return 'confirm';
		}

		return currentTab;
	}

	function getBackTab() {
		if ( currentTab === 'user-details' ) {
			return 'close';
		}

		if ( currentTab === 'billing-info' ) {

			return 'user-details';
		}
		if ( currentTab === 'payment-info' ) {
			return 'billing-info';
		}

		return currentTab;
	}

	function navigate( location ) {
		if ( currentTab === location ) {
			return;
		}

		currentTab = location;

		if ( location === 'billing-info') {
			$('#edd_checkout_user_info').hide();
			$('#edd_cc_address').show();
		}

		if ( location === 'payment-info') {
			$('#edd_cc_address').hide();
			$('#edd_payment_mode_select_wrap').show();
			$('#edd_cc_fields').show();
			$('#edd_purchase_submit').show();

		}

		// Hide other fieldset
		// Change breadcrumb
		$('.checkout-breadcrumbs li').removeClass('active');
		$('.checkout-breadcrumbs li.checkout-breadcrumb-' + location ).addClass('active');
	}

	// $( 'body' ).on( 'click', '.checkout-nav button', function() {
	// 	var btnType = $( this ).data( 'type' );
	// 	var nextTab;
	//
	// 	if ( !btnType ) {
	// 		return;
	// 	} else if ( btnType === 'next' ) {
	// 		nextTab = getNextTab();
	// 	} else {
	// 		nextTab = getBackTab();
	// 	}
	//
	// 	navigate( nextTab );
	// } );

	 $( 'body' ).on( 'click', '#checkout-login', function(e) {
	 	e.preventDefault;
	 	$('#edd_checkout_user_info').hide();
	 	$('#edd_checkout_login_register').show();
		 return false;
	 } );
	$( 'body' ).on( 'click', '#checkout-register', function(e) {
	 	e.preventDefault;
	 	$('#edd_checkout_user_info').show();
	 	$('#edd_checkout_login_register').hide();
		return false;
	 } );


} );
